/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import preview from 'ui/components/theme/preview.mixin';

const __vue_script__ = {
    name: 'WebPreview',

    mixins: [preview]
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "web-preview",
      attrs: {
        viewBox: "0 0 672 460",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip_page_shape)" } }, [
        _c("rect", {
          staticClass: "page_background",
          attrs: {
            width: "672",
            height: "460",
            rx: "8",
            fill: _vm.backgroundColor4 || "#FFFFFF",
          },
        }),
        _c("g", { staticClass: "menu" }, [
          _c("rect", {
            attrs: {
              x: "90.25",
              y: "43.25",
              width: "75.5",
              height: "62.5",
              rx: "1.75",
              fill: _vm.isV3 ? _vm.brandColor : _vm.color14,
            },
          }),
          _c("path", {
            attrs: {
              d: "M90.25 67.25H165.75V104C165.75 104.966 164.966 105.75 164 105.75H92C91.0335 105.75 90.25 104.966 90.25 104V67.25Z",
              fill: _vm.backgroundColor3 || _vm.color14,
            },
          }),
          _c("rect", {
            attrs: {
              x: "96",
              y: "83",
              width: "40",
              height: "4.10526",
              rx: "2",
              fill: _vm.foregroundColor1 || _vm.color6,
            },
          }),
          _c("rect", {
            attrs: {
              x: "96",
              y: "91.2104",
              width: "40",
              height: "4.10526",
              rx: "2",
              fill: _vm.foregroundColor2 || _vm.color7,
            },
          }),
          _c("path", {
            attrs: {
              d: "M90.25 67.25H165.75V104C165.75 104.966 164.966 105.75 164 105.75H92C91.0335 105.75 90.25 104.966 90.25 104V67.25Z",
              stroke: _vm.backgroundColor2,
              "stroke-width": "0.5",
            },
          }),
          _c("circle", {
            attrs: {
              cx: "109.5",
              cy: "66.5",
              r: "12.825",
              fill: _vm.brandColor,
              stroke: _vm.color2,
              "stroke-width": "1.35",
            },
          }),
          _c("path", {
            attrs: {
              d: "M102.323 70.7002H103.847V65.8328H103.931L107.454 70.7002H108.772V63.0906H107.248V67.9369H107.164L103.652 63.0906H102.323V70.7002ZM113.344 70.8953C115.243 70.8953 116.413 69.9408 116.413 68.4326V68.4273C116.413 67.2408 115.712 66.5975 114.104 66.2652L113.297 66.1018C112.4 65.9172 112.031 65.6219 112.031 65.1262V65.1209C112.031 64.5514 112.553 64.1928 113.339 64.1875C114.141 64.1875 114.668 64.5672 114.758 65.1104L114.768 65.1736H116.266L116.26 65.1051C116.16 63.8342 115.116 62.8955 113.339 62.8955C111.651 62.8955 110.439 63.8289 110.439 65.2422V65.2475C110.439 66.4023 111.119 67.1406 112.701 67.4623L113.502 67.6258C114.446 67.8209 114.821 68.1004 114.821 68.6014V68.6066C114.821 69.192 114.235 69.598 113.386 69.598C112.495 69.598 111.878 69.2131 111.82 68.6436L111.815 68.5908H110.28L110.286 68.6752C110.375 70.0252 111.525 70.8953 113.344 70.8953Z",
              fill: _vm.color2,
            },
          }),
          _c("rect", {
            attrs: {
              x: "90.25",
              y: "43.25",
              width: "75.5",
              height: "62.5",
              rx: "1.75",
              stroke: _vm.backgroundColor2 || "#E5E6E6",
              "stroke-width": "0.5",
            },
          }),
          _c("rect", {
            attrs: {
              x: "90",
              y: "114",
              width: "6",
              height: "6",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "100",
              y: "115",
              width: "56",
              height: "4",
              rx: "2",
              fill: _vm.foregroundColor1 || "#000000",
            },
          }),
          _c("rect", {
            attrs: {
              x: "90",
              y: "128",
              width: "6",
              height: "6",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "100",
              y: "129",
              width: "56",
              height: "4",
              rx: "2",
              fill: _vm.foregroundColor1 || "#000000",
            },
          }),
          _c("rect", {
            attrs: {
              x: "90",
              y: "142",
              width: "6",
              height: "6",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "100",
              y: "143",
              width: "56",
              height: "4",
              rx: "2",
              fill: _vm.foregroundColor1 || "#000000",
            },
          }),
          _c("rect", {
            attrs: {
              x: "90",
              y: "156",
              width: "6",
              height: "6",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "100",
              y: "157",
              width: "56",
              height: "4",
              rx: "2",
              fill: _vm.foregroundColor1 || "#000000",
            },
          }),
          _c("rect", {
            attrs: {
              x: "90",
              y: "170",
              width: "6",
              height: "6",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "100",
              y: "171",
              width: "56",
              height: "4",
              rx: "2",
              fill: _vm.foregroundColor1 || "#000000",
            },
          }),
          _c("rect", {
            attrs: {
              x: "90",
              y: "184",
              width: "6",
              height: "6",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "100",
              y: "185",
              width: "56",
              height: "4",
              rx: "2",
              fill: _vm.foregroundColor1 || "#000000",
            },
          }),
          _c("rect", {
            attrs: {
              x: "90",
              y: "198",
              width: "6",
              height: "6",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "100",
              y: "199",
              width: "56",
              height: "4",
              rx: "2",
              fill: _vm.foregroundColor1 || "#000000",
            },
          }),
          _c("rect", {
            attrs: {
              x: "90",
              y: "212",
              width: "6",
              height: "6",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color4 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "100",
              y: "213",
              width: "56",
              height: "4",
              rx: "2",
              fill: _vm.foregroundColor1 || "#000000",
            },
          }),
        ]),
        _c("g", { staticClass: "page_title" }, [
          _c("rect", {
            attrs: {
              x: "182.5",
              y: "43.5",
              width: "40.4",
              height: "7",
              rx: "1.5",
              fill: "#E3E6E8",
              stroke: _vm.backgroundColor2 || "#E5E6E6",
            },
          }),
        ]),
        _vm.banner
          ? _c(
              "g",
              {
                staticClass: "banner",
                attrs: { transform: "translate(182 " + _vm.pageTop + ")" },
              },
              [
                _c("image", {
                  ref: "banner",
                  attrs: {
                    href: _vm.banner,
                    x: "0",
                    y: "0",
                    width: "314",
                    "clip-path": "url(#clip_round_banner)",
                    preserveAspectRatio: "xMidYMid meet",
                  },
                  on: { load: _vm.onBannerLoad },
                }),
              ]
            )
          : _vm._e(),
        _c(
          "g",
          {
            staticClass: "create_post_box",
            attrs: { transform: "translate(182 " + _vm.createPostBoxTop + ")" },
          },
          [
            _c("rect", {
              attrs: {
                x: "0.25",
                y: "0.25",
                width: "313.5",
                height: "61.5",
                rx: "3.75",
                fill: _vm.backgroundColor3 || "#FFFFFF",
              },
            }),
            _c("circle", {
              attrs: { cx: "19", cy: "19", r: "9", fill: "#E3E6E8" },
            }),
            _c("rect", {
              attrs: {
                x: "36",
                y: "15",
                width: "46",
                height: "8",
                rx: "2",
                fill: "#E3E6E8",
              },
            }),
            _c("rect", {
              attrs: {
                x: "10",
                y: "40",
                width: "12",
                height: "12",
                rx: "2",
                fill: _vm.brandColor,
              },
            }),
            _c("rect", {
              attrs: {
                x: "0.25",
                y: "0.25",
                width: "313.5",
                height: "61.5",
                rx: "3.75",
                stroke: _vm.backgroundColor2 || "#E5E6E6",
                "stroke-width": "0.5",
              },
            }),
          ]
        ),
        _vm.quickLinks
          ? _c(
              "g",
              {
                staticClass: "quick_links",
                attrs: {
                  transform: "translate(182 " + _vm.quickLinksTop + ")",
                },
              },
              [
                _c(
                  "g",
                  { attrs: { "clip-path": "url(#clip_quick_links)" } },
                  [
                    _c("rect", {
                      attrs: {
                        x: "0.25",
                        y: "0.25",
                        width: "313.5",
                        height: "57.5",
                        rx: "3.75",
                        fill: _vm.backgroundColor3 || "#FFFFFF",
                      },
                    }),
                    _vm._l(_vm.quickLinks, function (i) {
                      return [
                        _c("rect", {
                          attrs: {
                            x: 12 + 65.4 * (i - 1),
                            y: "37",
                            width: "41.4",
                            height: "8",
                            rx: "2",
                            fill: "#E3E6E8",
                          },
                        }),
                        _c("ellipse", {
                          attrs: {
                            cx: 32.7 + 65.4 * (i - 1),
                            cy: "22",
                            rx: "9",
                            ry: "9",
                            fill: "#E3E6E8",
                          },
                        }),
                      ]
                    }),
                    _c("rect", {
                      attrs: {
                        x: "0.25",
                        y: "0.25",
                        width: "313.5",
                        height: "57.5",
                        rx: "3.75",
                        stroke: _vm.backgroundColor2 || "#E5E6E6",
                        "stroke-width": "0.5",
                      },
                    }),
                  ],
                  2
                ),
                _vm.quickLinks > 4
                  ? [
                      _c("rect", {
                        attrs: {
                          x: "238",
                          y: "1",
                          width: "24",
                          height: "24",
                          rx: "12",
                          transform: "rotate(-90 278 1)",
                          fill: _vm.brandColor,
                          opacity: ".5",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M287.671 34.193C287.544 34.193 287.424 34.144 287.334 34.053C287.149 33.868 287.149 33.566 287.334 33.38L291.854 28.861L287.334 24.342C287.244 24.252 287.195 24.132 287.195 24.005C287.195 23.878 287.244 23.758 287.334 23.669C287.424 23.579 287.544 23.529 287.671 23.529C287.798 23.529 287.918 23.579 288.007 23.669L292.527 28.188C292.897 28.559 292.898 29.163 292.527 29.533L288.007 34.053C287.918 34.144 287.798 34.193 287.671 34.193Z",
                          fill: _vm.color2,
                          stroke: _vm.color2,
                        },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "68",
                          y: "-33",
                          width: "24",
                          height: "24",
                          rx: "12",
                          transform: "rotate(90 28 -23)",
                          fill: _vm.brandColor,
                          opacity: ".5",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M28.329 23.807C28.456 23.807 28.576 23.856 28.666 23.947C28.851 24.132 28.851 24.434 28.666 24.62L24.146 29.139L28.666 33.658C28.756 33.748 28.805 33.868 28.805 33.995C28.805 34.122 28.756 34.242 28.666 34.331C28.576 34.421 28.456 34.471 28.329 34.471C28.202 34.471 28.082 34.421 27.993 34.331L23.473 29.812C23.103 29.441 23.102 28.837 23.473 28.467L27.993 23.947C28.082 23.856 28.202 23.807 28.329 23.807Z",
                          fill: _vm.color2,
                          stroke: _vm.color2,
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm.pinnedPost
          ? _c(
              "g",
              {
                staticClass: "pinned_post",
                attrs: {
                  transform: "translate(182 " + _vm.pinnedPostTop + ")",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "0.25",
                    y: "0.25",
                    width: "313.5",
                    height: "75.5",
                    rx: "3.75",
                    fill: _vm.backgroundColor3 || "#FFFFFF",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "0.25",
                    y: "0.25",
                    width: "313.5",
                    height: "75.5",
                    rx: "3.75",
                    stroke: _vm.backgroundColor2 || "#E5E6E6",
                    "stroke-width": "0.5",
                  },
                }),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M10.11 21.89C10.1805 21.961 10.275 22 10.375 22C10.475 22 10.5695 21.961 10.64 21.8905L14.3783 18.1527L16.1662 19.9411C16.3782 20.1536 16.6607 20.2711 16.9627 20.2716C17.2627 20.2716 17.5447 20.1551 17.7567 19.9436C17.8247 19.8756 17.8842 19.7986 17.9337 19.7146C18.4231 18.8721 18.5991 17.8892 18.4336 16.9337L21.4795 14.9953C21.7325 14.8343 21.908 14.5838 21.9735 14.2903C22.0385 13.9968 21.986 13.6958 21.825 13.4429C21.781 13.3744 21.7295 13.3099 21.671 13.2509L18.7496 10.3295C18.5371 10.117 18.2547 10 17.9542 10C17.6537 10 17.3712 10.117 17.1592 10.3295C17.1012 10.387 17.0497 10.4515 17.0052 10.521L15.0668 13.5679C14.8328 13.5274 14.5958 13.5069 14.3598 13.5069C13.6348 13.5069 12.9179 13.7008 12.2849 14.0688C12.0254 14.2208 11.8409 14.4648 11.7654 14.7558C11.6899 15.0468 11.7319 15.3498 11.8839 15.6088C11.9324 15.6918 11.9919 15.7683 12.0594 15.8358L13.8468 17.6232L10.11 21.36C10.039 21.4305 10 21.525 10 21.625C10 21.725 10.039 21.8195 10.11 21.89ZM12.6629 14.7168C13.1799 14.4163 13.7668 14.2573 14.3598 14.2573C14.6268 14.2573 14.8948 14.2888 15.1563 14.3518C15.1848 14.3588 15.2143 14.3623 15.2438 14.3623C15.3728 14.3623 15.4908 14.2978 15.5603 14.1888L17.6377 10.924C17.6527 10.901 17.6697 10.8795 17.6892 10.86C17.7597 10.789 17.8542 10.75 17.9542 10.75C18.0547 10.75 18.1487 10.789 18.2197 10.86L21.14 13.7813C21.1595 13.8008 21.177 13.8223 21.1915 13.8453C21.245 13.9298 21.2625 14.0303 21.241 14.1278C21.219 14.2258 21.1605 14.3088 21.076 14.3628L17.8117 16.4402C17.6767 16.5262 17.6112 16.6887 17.6487 16.8442C17.8537 17.6952 17.7242 18.5806 17.2847 19.3366C17.2687 19.3641 17.2492 19.3891 17.2262 19.4121C17.1557 19.4826 17.0617 19.5211 16.9617 19.5211C16.8612 19.5211 16.7667 19.4821 16.6957 19.4111L12.5889 15.3043C12.5664 15.2818 12.5469 15.2568 12.5304 15.2288C12.4799 15.1428 12.4654 15.0418 12.4909 14.9448C12.5164 14.8478 12.5779 14.7668 12.6629 14.7168Z",
                    fill: _vm.brandColor,
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M10.11 21.89L10.4648 21.5377L10.4623 21.5352L10.11 21.89ZM10.64 21.8905L10.2864 21.5369L10.2864 21.537L10.64 21.8905ZM14.3783 18.1527L14.7319 17.7992L14.3784 17.4455L14.0248 17.7991L14.3783 18.1527ZM16.1662 19.9411L16.5202 19.5879L16.5198 19.5876L16.1662 19.9411ZM16.9627 20.2716L16.9619 20.7716H16.9627V20.2716ZM17.7567 19.9436L18.1098 20.2976L18.1102 20.2971L17.7567 19.9436ZM17.9337 19.7146L18.3644 19.9684L18.366 19.9658L17.9337 19.7146ZM18.4336 16.9337L18.1652 16.5119L17.8841 16.6908L17.941 17.019L18.4336 16.9337ZM21.4795 14.9953L21.2111 14.5735L21.2111 14.5735L21.4795 14.9953ZM21.9735 14.2903L22.4615 14.3992L22.4617 14.3984L21.9735 14.2903ZM21.825 13.4429L22.2468 13.1744L22.2457 13.1726L21.825 13.4429ZM21.671 13.2509L22.0261 12.8988L22.0246 12.8973L21.671 13.2509ZM18.7496 10.3295L18.3961 10.683V10.683L18.7496 10.3295ZM17.1592 10.3295L17.5112 10.6846L17.5132 10.6826L17.1592 10.3295ZM17.0052 10.521L16.5841 10.2514L16.5833 10.2526L17.0052 10.521ZM15.0668 13.5679L14.9815 14.0605L15.3098 14.1173L15.4887 13.8362L15.0668 13.5679ZM12.2849 14.0688L12.0336 13.6366L12.0322 13.6374L12.2849 14.0688ZM11.8839 15.6088L12.3156 15.3565L12.3151 15.3557L11.8839 15.6088ZM12.0594 15.8358L11.7059 16.1893H11.7059L12.0594 15.8358ZM13.8468 17.6232L14.2004 17.9767L14.5539 17.6232L14.2004 17.2696L13.8468 17.6232ZM10.11 21.36L10.4623 21.7148L10.4635 21.7136L10.11 21.36ZM12.6629 14.7168L12.4116 14.2845L12.4094 14.2858L12.6629 14.7168ZM15.1563 14.3518L15.2755 13.8662L15.2734 13.8657L15.1563 14.3518ZM15.5603 14.1888L15.9819 14.4576L15.9821 14.4572L15.5603 14.1888ZM17.6377 10.924L17.2189 10.6508L17.2158 10.6555L17.6377 10.924ZM17.6892 10.86L18.0427 11.2135L18.044 11.2123L17.6892 10.86ZM18.2197 10.86L18.5733 10.5065L18.5732 10.5064L18.2197 10.86ZM21.14 13.7813L20.7864 14.1348L20.7865 14.1349L21.14 13.7813ZM21.1915 13.8453L20.7686 14.112L20.7691 14.1128L21.1915 13.8453ZM21.241 14.1278L21.7289 14.2373L21.7293 14.2355L21.241 14.1278ZM21.076 14.3628L21.3445 14.7846L21.3453 14.7841L21.076 14.3628ZM17.8117 16.4402L17.5432 16.0184L17.543 16.0185L17.8117 16.4402ZM17.6487 16.8442L18.1348 16.7271L18.1347 16.727L17.6487 16.8442ZM17.2847 19.3366L17.7169 19.5881L17.717 19.5879L17.2847 19.3366ZM17.2262 19.4121L16.8726 19.0586L16.8726 19.0586L17.2262 19.4121ZM16.6957 19.4111L17.0493 19.0576L16.6957 19.4111ZM12.5889 15.3043L12.2353 15.6578L12.5889 15.3043ZM12.5304 15.2288L12.0992 15.482L12.0996 15.4826L12.5304 15.2288ZM12.4909 14.9448L12.0073 14.8177L12.0073 14.8177L12.4909 14.9448ZM10.375 21.5C10.4071 21.5 10.4406 21.5134 10.4648 21.5377L9.75519 22.2423C9.92035 22.4086 10.1429 22.5 10.375 22.5V21.5ZM10.2864 21.537C10.3102 21.5132 10.3431 21.5 10.375 21.5V22.5C10.6069 22.5 10.8288 22.4088 10.9935 22.2441L10.2864 21.537ZM14.0248 17.7991L10.2864 21.5369L10.9935 22.2441L14.7318 18.5062L14.0248 17.7991ZM16.5198 19.5876L14.7319 17.7992L14.0247 18.5062L15.8126 20.2946L16.5198 19.5876ZM16.9635 19.7716C16.7937 19.7713 16.6383 19.7063 16.5202 19.5879L15.8123 20.2942C16.1182 20.6008 16.5278 20.7709 16.9619 20.7716L16.9635 19.7716ZM17.4035 19.5896C17.2855 19.7074 17.1306 19.7716 16.9627 19.7716V20.7716C17.3948 20.7716 17.8039 20.6027 18.1098 20.2976L17.4035 19.5896ZM17.5029 19.4607C17.4745 19.5089 17.4408 19.5523 17.4031 19.59L18.1102 20.2971C18.2085 20.1988 18.2938 20.0882 18.3644 19.9684L17.5029 19.4607ZM17.941 17.019C18.0864 17.8585 17.9319 18.7224 17.5013 19.4634L18.366 19.9658C18.9144 19.0219 19.1119 17.9198 18.9263 16.8484L17.941 17.019ZM21.2111 14.5735L18.1652 16.5119L18.7021 17.3555L21.748 15.4171L21.2111 14.5735ZM21.4855 14.1814C21.4488 14.3461 21.3519 14.4838 21.2111 14.5735L21.748 15.4171C22.1131 15.1848 22.3673 14.8215 22.4615 14.3992L21.4855 14.1814ZM21.4032 13.7113C21.4926 13.8518 21.5219 14.0173 21.4853 14.1822L22.4617 14.3984C22.5551 13.9764 22.4794 13.5399 22.2468 13.1744L21.4032 13.7113ZM21.316 13.6029C21.3495 13.6367 21.3791 13.6737 21.4043 13.7131L22.2457 13.1726C22.183 13.075 22.1095 12.983 22.0261 12.8988L21.316 13.6029ZM18.3961 10.683L21.3175 13.6044L22.0246 12.8973L19.1032 9.97593L18.3961 10.683ZM17.9542 10.5C18.1221 10.5 18.2774 10.5643 18.3961 10.683L19.1032 9.97593C18.7969 9.66966 18.3873 9.5 17.9542 9.5V10.5ZM17.5132 10.6826C17.6311 10.5644 17.7862 10.5 17.9542 10.5V9.5C17.5212 9.5 17.1113 9.66961 16.8052 9.97635L17.5132 10.6826ZM17.4263 10.7906C17.4522 10.7502 17.4808 10.7147 17.5112 10.6846L16.8072 9.97441C16.7216 10.0593 16.6473 10.1528 16.5841 10.2514L17.4263 10.7906ZM15.4887 13.8362L17.4271 10.7894L16.5833 10.2526L14.6449 13.2995L15.4887 13.8362ZM14.3598 14.0069C14.5669 14.0069 14.7754 14.0249 14.9815 14.0605L15.1521 13.0752C14.8902 13.0299 14.6247 13.0069 14.3598 13.0069V14.0069ZM12.5362 14.5011C13.0935 14.1771 13.7239 14.0069 14.3598 14.0069V13.0069C13.5458 13.0069 12.7422 13.2246 12.0336 13.6366L12.5362 14.5011ZM12.2494 14.8814C12.2915 14.7191 12.3928 14.5851 12.5376 14.5003L12.0322 13.6374C11.6581 13.8565 11.3903 14.2106 11.2815 14.6302L12.2494 14.8814ZM12.3151 15.3557C12.2304 15.2112 12.2071 15.0445 12.2494 14.8814L11.2815 14.6302C11.1728 15.0491 11.2335 15.4883 11.4527 15.8618L12.3151 15.3557ZM12.413 15.4822C12.3749 15.4441 12.3419 15.4015 12.3156 15.3565L11.4522 15.861C11.5229 15.982 11.6089 16.0924 11.7059 16.1893L12.413 15.4822ZM14.2004 17.2696L12.413 15.4822L11.7059 16.1893L13.4933 17.9767L14.2004 17.2696ZM10.4635 21.7136L14.2004 17.9767L13.4933 17.2696L9.75644 21.0065L10.4635 21.7136ZM10.5 21.625C10.5 21.6571 10.4866 21.6907 10.4623 21.7148L9.75769 21.0052C9.59137 21.1704 9.5 21.3929 9.5 21.625H10.5ZM10.4623 21.5352C10.4866 21.5594 10.5 21.5929 10.5 21.625H9.5C9.5 21.8571 9.59137 22.0797 9.75769 22.2448L10.4623 21.5352ZM14.3598 13.7573C13.6778 13.7573 13.0042 13.9401 12.4116 14.2845L12.9141 15.1491C13.3555 14.8925 13.8559 14.7573 14.3598 14.7573V13.7573ZM15.2734 13.8657C14.9733 13.7934 14.666 13.7573 14.3598 13.7573V14.7573C14.5876 14.7573 14.8163 14.7842 15.0392 14.8379L15.2734 13.8657ZM15.2438 13.8623C15.2536 13.8623 15.2641 13.8635 15.2755 13.8663L15.037 14.8374C15.1054 14.8542 15.175 14.8623 15.2438 14.8623V13.8623ZM15.1387 13.92C15.1612 13.8847 15.2023 13.8623 15.2438 13.8623V14.8623C15.5432 14.8623 15.8203 14.7109 15.9819 14.4576L15.1387 13.92ZM17.2158 10.6555L15.1384 13.9204L15.9821 14.4572L18.0595 11.1924L17.2158 10.6555ZM17.3356 10.5064C17.2888 10.5532 17.2504 10.6024 17.2189 10.6508L18.0565 11.1971C18.0549 11.1995 18.0506 11.2057 18.0427 11.2135L17.3356 10.5064ZM17.9542 10.25C17.7221 10.25 17.4995 10.3413 17.3344 10.5077L18.044 11.2123C18.0198 11.2366 17.9863 11.25 17.9542 11.25V10.25ZM18.5732 10.5064C18.4086 10.3418 18.1874 10.25 17.9542 10.25V11.25C17.9219 11.25 17.8888 11.2362 17.8661 11.2135L18.5732 10.5064ZM21.4936 13.4278L18.5733 10.5065L17.866 11.2135L20.7864 14.1348L21.4936 13.4278ZM21.6145 13.5787C21.5784 13.5214 21.5369 13.4711 21.4936 13.4278L20.7865 14.1349C20.7821 14.1306 20.7757 14.1233 20.7686 14.112L21.6145 13.5787ZM21.7293 14.2355C21.7791 14.0095 21.7382 13.7741 21.614 13.5779L20.7691 14.1128C20.7518 14.0855 20.7459 14.0511 20.7528 14.0202L21.7293 14.2355ZM21.3453 14.7841C21.5402 14.6595 21.6778 14.4648 21.7289 14.2373L20.7532 14.0183C20.7602 13.9868 20.7808 13.9581 20.8068 13.9415L21.3453 14.7841ZM18.0801 16.8621L21.3445 14.7846L20.8076 13.941L17.5432 16.0184L18.0801 16.8621ZM18.1347 16.727C18.1473 16.7791 18.1255 16.8331 18.0803 16.8619L17.543 16.0185C17.2278 16.2193 17.0751 16.5984 17.1626 16.9614L18.1347 16.727ZM17.717 19.5879C18.2212 18.7206 18.3699 17.7032 18.1348 16.7271L17.1626 16.9613C17.3374 17.6872 17.2272 18.4407 16.8524 19.0853L17.717 19.5879ZM17.5798 19.7657C17.6314 19.714 17.6779 19.655 17.7169 19.5881L16.8525 19.0852C16.8595 19.0732 16.867 19.0642 16.8726 19.0586L17.5798 19.7657ZM16.9617 20.0211C17.1926 20.0211 17.4143 19.9311 17.5798 19.7657L16.8726 19.0586C16.8971 19.0341 16.9308 19.0211 16.9617 19.0211V20.0211ZM16.3422 19.7647C16.5073 19.9298 16.7292 20.0211 16.9617 20.0211V19.0211C16.9933 19.0211 17.0261 19.0344 17.0493 19.0576L16.3422 19.7647ZM12.2353 15.6578L16.3422 19.7647L17.0493 19.0576L12.9424 14.9507L12.2353 15.6578ZM12.0996 15.4826C12.1379 15.5476 12.1835 15.606 12.2353 15.6578L12.9424 14.9507C12.9493 14.9576 12.9559 14.966 12.9612 14.9749L12.0996 15.4826ZM12.0073 14.8177C11.9476 15.045 11.9822 15.2827 12.0992 15.482L12.9616 14.9756C12.9776 15.0028 12.9832 15.0385 12.9745 15.0719L12.0073 14.8177ZM12.4094 14.2858C12.21 14.4031 12.0662 14.5937 12.0073 14.8177L12.9745 15.0719C12.9666 15.1019 12.9458 15.1305 12.9164 15.1478L12.4094 14.2858Z",
                    fill: _vm.brandColor,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "30",
                    y: "12",
                    width: "46",
                    height: "8",
                    rx: "2",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "10",
                    y: "34",
                    width: "294",
                    height: "8",
                    rx: "2",
                    fill: "#BEBFC1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "10",
                    y: "46",
                    width: "144",
                    height: "8",
                    rx: "2",
                    fill: "#BEBFC1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "10",
                    y: "62",
                    width: "19",
                    height: "4",
                    rx: "2",
                    fill: _vm.brandColor,
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "37",
                    y: "62",
                    width: "19",
                    height: "4",
                    rx: "2",
                    fill: _vm.brandColor,
                  },
                }),
              ]
            )
          : _vm._e(),
        _c(
          "g",
          {
            staticClass: "other_posts",
            attrs: { transform: "translate(182 " + _vm.otherPostsTop + ")" },
          },
          [
            _vm._l(4, function (i) {
              return [
                _c("rect", {
                  attrs: {
                    x: "0.25",
                    y: 79.5 * (i - 1) + 0.25,
                    width: "313.5",
                    height: "71.5",
                    rx: "3.75",
                    fill: _vm.backgroundColor3 || "#FFFFFF",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "0.25",
                    y: 79.5 * (i - 1) + 0.25,
                    width: "313.5",
                    height: "71.5",
                    rx: "3.75",
                    stroke: _vm.backgroundColor2 || "#E5E6E6",
                    "stroke-width": "0.5",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "10",
                    y: 79.5 * (i - 1) + 10,
                    width: "46",
                    height: "8",
                    rx: "2",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "10",
                    y: 79.5 * (i - 1) + 30,
                    width: "294",
                    height: "8",
                    rx: "2",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "10",
                    y: 79.5 * (i - 1) + 42,
                    width: "144",
                    height: "8",
                    rx: "2",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "10",
                    y: 79.5 * (i - 1) + 58,
                    width: "19",
                    height: "4",
                    rx: "2",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "37",
                    y: 79.5 * (i - 1) + 58,
                    width: "19",
                    height: "4",
                    rx: "2",
                    fill: "#E5E6E6",
                  },
                }),
              ]
            }),
          ],
          2
        ),
        _c("g", { staticClass: "top_bar" }, [
          _c("rect", {
            attrs: {
              width: "672",
              height: "26",
              transform: "translate(0 1)",
              fill: _vm.backgroundColor3 || _vm.brandColor,
            },
          }),
          _c("rect", {
            attrs: {
              x: "86",
              y: "6",
              width: "56",
              height: "16",
              rx: "8",
              fill: _vm.backgroundColor3 || _vm.color2,
            },
          }),
          _c("rect", {
            attrs: {
              x: "90",
              y: "10",
              width: "8",
              height: "8",
              rx: "2",
              fill: _vm.tintIcons ? _vm.brandColor : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "102",
              y: "10",
              width: "36",
              height: "8",
              rx: "2",
              fill: _vm.brandColor || _vm.color2,
            },
          }),
          _c("rect", {
            attrs: {
              x: "154",
              y: "10",
              width: "8",
              height: "8",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color2 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "166",
              y: "10",
              width: "36",
              height: "8",
              rx: "2",
              fill: _vm.foregroundColor1 || _vm.color2,
            },
          }),
          _c("rect", {
            attrs: {
              x: "218",
              y: "10",
              width: "8",
              height: "8",
              rx: "2",
              fill: _vm.tintIcons ? _vm.color2 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "230",
              y: "10",
              width: "36",
              height: "8",
              rx: "2",
              fill: _vm.foregroundColor1 || _vm.color2,
            },
          }),
          _c("rect", {
            attrs: {
              x: "282",
              y: "10",
              width: "8",
              height: "8",
              rx: "2",
              fill: _vm.tintIcons ? _vm.foregroundColor1 : "#E5E6E6",
            },
          }),
          _c("rect", {
            attrs: {
              x: "294",
              y: "10",
              width: "36",
              height: "8",
              rx: "2",
              fill: _vm.foregroundColor1,
            },
          }),
          _c("g", { staticClass: "search", attrs: { opacity: "0.8" } }, [
            _c("rect", {
              attrs: {
                x: "496",
                y: "8",
                width: "86",
                height: "12",
                rx: "6",
                fill: _vm.foregroundColor2 || "#FFFFFF",
              },
            }),
          ]),
        ]),
        _c("rect", {
          staticClass: "page_borders",
          attrs: {
            x: "0.5",
            y: "0.5",
            width: "671",
            height: "459",
            rx: "7.5",
            stroke: _vm.backgroundColor2 || "#E5E6E6",
          },
        }),
        _c("defs", [
          _c("clipPath", { attrs: { id: "clip_page_shape" } }, [
            _c("rect", {
              attrs: { width: "672", height: "460", rx: "8", fill: "white" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "clip_round_banner" } }, [
            _c("rect", {
              attrs: {
                x: "0",
                y: "0",
                width: "314",
                height: _vm.bannerHeight,
                rx: "4",
                fill: "white",
              },
            }),
          ]),
          _c("clipPath", { attrs: { id: "clip_quick_links" } }, [
            _c("rect", {
              attrs: { width: "314", height: "58", fill: "white" },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/theme/WebPreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__